import { render, staticRenderFns } from "./CheckInOutApprovalDetail.vue?vue&type=template&id=45d72954&scoped=true&"
import script from "./CheckInOutApprovalDetail.vue?vue&type=script&scoped=true&lang=js&"
export * from "./CheckInOutApprovalDetail.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./CheckInOutApprovalDetail.vue?vue&type=style&index=0&id=45d72954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d72954",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VTextField})
